const modReqd = item => {
  return item.mod_reqd == null || `${item.mod_reqd}`.trim() == ''
    ? false
    : parseInt(item.mod_reqd, 10) === 3;
};

/*
  mod_reqd
  tinyint
  Default: 0
  0 or 1 = N / A, 2 = prompt, 3 = prompt and required
*/

export default modReqd;
